var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"position":"absolute","margin-top":"300px","margin-left":"210px"}},[_c('v-progress-circular',{attrs:{"size":"80","indeterminate":"","color":"gray"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }